import {
  FIND_MY_PART_RECEIVE,
  FIND_MY_PART_RECEIVE_OPTIONS,
  FIND_MY_PART_RECEIVE_SEGMENTS,
  FIND_MY_PART_ERROR,
  FIND_MY_PART_CHANGE_MODE,
  FIND_MY_PART_RECEIVE_SEARCH_ITEMS,
  PRODUCT_CONFIGURATOR_RECEIVE,
  PRODUCT_CONFIGURATOR_SEND,
  PRODUCT_CONFIGURATOR_UPDATE,
  PRODUCT_CONFIGURATOR_BUTTON_STATUS,
  ViewMode,
} from '../constants';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
  segments: [],
  searchItems: [],
  products: [],
  variantItems: [],
  options: {},
  mode: ViewMode.List,

  variantData: [],
  configMessage: '',
  returnMessage: '',
  buyButtonStatusClass: '',

  errors: {},
};

export const findMyPart = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FIND_MY_PART_RECEIVE:
    case FIND_MY_PART_RECEIVE_OPTIONS:
    case FIND_MY_PART_RECEIVE_SEGMENTS:
    case FIND_MY_PART_CHANGE_MODE:
    case FIND_MY_PART_RECEIVE_SEARCH_ITEMS:
    case PRODUCT_CONFIGURATOR_RECEIVE:
    case PRODUCT_CONFIGURATOR_SEND:
    case PRODUCT_CONFIGURATOR_UPDATE:
    case PRODUCT_CONFIGURATOR_BUTTON_STATUS:
      return {
        ...state,
        errors: {},
        ...payload,
      };
    case FIND_MY_PART_ERROR:
      return {
        ...state,
        errors: errorReducer(state.errors, action),
      };
    default:
      return state;
  }
};
